import { ru } from './ru_RU'

export type TLang = 'ru' | 'en'
export type TTranslations = typeof ru

export const locale = 'ru_RU'
export const t: TTranslations = Object.assign({}, ru)
